import { BaseEntity } from "yt-ng-framework";

export class ZaposleniView extends BaseEntity{
    constructor(){
        super();
    }

    Ime: string = null;
    Prezime: string = null;
    Jmbg: string = null;
    Pol: string = null;
    PrezimeIIme: string = null

    Deserialize(input: any){
        this.ID=input.ID;
        this.Ime=input.Ime;
        this.Prezime=input.Prezime;
        this.Jmbg=input.Jmbg;
        this.Pol=input.Pol;
        this.PrezimeIIme=input.PrezimeIIme;
        return this;
    }

    Serialize(input:ZaposleniView){
        return input;
    }
}